<script>

import { notificationMethods } from "@/state/helpers";
import BaseLoader from "./components/BaseLoader";
import { EventBus } from '@/helpers/eventBus';

export default {
  name: "app",
  components: {
    BaseLoader
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | Anytime Bigz` : 'Anytime Bigz';
    }
  },
  mounted() {
    EventBus.$on('show-toast', (toastConfig) => {
      this.pushToast(toastConfig)
    });
  },
  beforeDestroy() {
    EventBus.$off('show-toast');
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();

      // Clear error bag on location change
      this.$store.commit('errorBag/CLEAR');
    }
  },
  methods: {
    pushToast(toastConfig) {
      this.$bvToast.toast(toastConfig.message, {
        autoHideDelay: toastConfig.autoHideDelay,
        appendToast: true,
        solid: true,
        variant: toastConfig.variant,
        title: toastConfig.title, 
        toaster: toastConfig.toaster,
        bodyClass: 'scrollable-toast'
      });
    },
    clearNotification: notificationMethods.clear
  },
  destroyed() {
    this.$scheduler.stopTasks();
  }
};
</script>

<template>
  <div id="app">
    <BaseLoader v-if="$store.state.loader.loading" />
    <RouterView />
  </div>
</template>
